import { useEffect, useMemo, useState } from "react"
import petrolImg from "../assets/petrol.png"

const defaultItems = [
  {
    title: "Asphalt Concrete Paver",
    image: "/avvv.png",
  },
  {
    title: "Asphalt Concrete Paver",
    image: "/avvv.png",
  },
  {
    title: "Asphalt Concrete Paver",
    image: "/avvv.png",
  },
  {
    title: "Asphalt Concrete Paver",
    image: "/avvv.png",
  },
  {
    title: "Asphalt Concrete Paver",
    image: "/avvv.png",
  },
  {
    title: "Asphalt Concrete Paver",
    image: "/avvv.png",
  },
]

const visibleCardCount = 3
const autoSlideDelay = 5000

function ArrowButton({ children, onClick, label, className = "" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={`flex h-10 w-10 items-center justify-center rounded-full bg-[#ed860f] text-3xl font-bold leading-none text-white shadow-md transition hover:bg-[#d9780d] sm:h-11 sm:w-11 ${className}`}
    >
      {children}
    </button>
  )
}

export default function SupportedEquipmentTypes({
  title = "Supported Equipment Types",
  items = defaultItems,
}) {
  const safeItems = items.length ? items : defaultItems
  const [activeIndex, setActiveIndex] = useState(0)
  const [slideDirection, setSlideDirection] = useState("next")
  const [isPaused, setIsPaused] = useState(false)

  const visibleItems = useMemo(() => {
    const count = Math.min(visibleCardCount, safeItems.length)

    return Array.from({ length: count }, (_, offset) => {
      const index = (activeIndex + offset) % safeItems.length

      return {
        ...safeItems[index],
        originalIndex: index,
      }
    })
  }, [activeIndex, safeItems])

  useEffect(() => {
    if (isPaused || safeItems.length <= 1) return undefined

    const interval = setInterval(() => {
      setSlideDirection("next")
      setActiveIndex((prev) => (prev + 1) % safeItems.length)
    }, autoSlideDelay)

    return () => clearInterval(interval)
  }, [isPaused, safeItems.length])

  const previous = () => {
    setSlideDirection("previous")
    setActiveIndex((prev) => (prev - 1 + safeItems.length) % safeItems.length)
  }

  const next = () => {
    setSlideDirection("next")
    setActiveIndex((prev) => (prev + 1) % safeItems.length)
  }

  return (
    <section
      className="bg-white py-14 sm:py-16 lg:py-20"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <style>
        {`
          @keyframes equipmentSlideNext {
            from {
              opacity: 0.85;
              transform: translateX(34px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes equipmentSlidePrevious {
            from {
              opacity: 0.85;
              transform: translateX(-34px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          .equipment-slide-next {
            animation: equipmentSlideNext 0.45s ease both;
          }

          .equipment-slide-previous {
            animation: equipmentSlidePrevious 0.45s ease both;
          }
        `}
      </style>

      <div className="mx-auto w-full max-w-[1490px] px-5 sm:px-8 lg:px-12 xl:px-20">
        <h2 className="mb-10 text-center text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
          {title}
        </h2>

        <div className="relative mx-auto max-w-[1380px] px-12 sm:px-16 lg:px-20">
          {safeItems.length > 1 && (
            <ArrowButton
              onClick={previous}
              label="Previous equipment"
              className="absolute left-0 top-[135px] z-10 sm:top-[165px] lg:top-[190px]"
            >
              ‹
            </ArrowButton>
          )}

          <div
            key={`${activeIndex}-${slideDirection}`}
            className={`grid grid-cols-1 gap-5 md:grid-cols-3 lg:gap-6 ${
              slideDirection === "next"
                ? "equipment-slide-next"
                : "equipment-slide-previous"
            }`}
          >
            {visibleItems.map((item, index) => (
              <article
                key={`${item.title}-${item.originalIndex}-${index}`}
                className={`${index > 0 ? "hidden md:block" : ""} bg-white`}
              >
                <div className="h-[270px] overflow-hidden rounded-lg bg-black shadow-sm sm:h-[330px] lg:h-[380px]">
                  <img
                    src={item.image || petrolImg}
                    alt={item.title}
                    className="h-full w-full object-cover"
                    onError={(event) => {
                      event.currentTarget.onerror = null
                      event.currentTarget.src = petrolImg
                    }}
                  />
                </div>

                <h3 className="mt-4 text-center text-xl font-semibold leading-tight text-black sm:text-2xl lg:text-[26px]">
                  {item.title}
                </h3>
              </article>
            ))}
          </div>

          {safeItems.length > 1 && (
            <ArrowButton
              onClick={next}
              label="Next equipment"
              className="absolute right-0 top-[135px] z-10 sm:top-[165px] lg:top-[190px]"
            >
              ›
            </ArrowButton>
          )}
        </div>
      </div>
    </section>
  )
}